import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const OAuthCallback = () => {
  const { setIsAuthenticated } = useAuth();
  let [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      localStorage.setItem('token', token);
      setIsAuthenticated(true);
      window.location.href = '/'; 
    } else {
      window.location.href = '/login'; 
    }
  }, [searchParams, setIsAuthenticated]);

  return <div>Authenticating...</div>;
};

export default OAuthCallback;
